<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />

            <!-- Page Header -->
            <div class="ps-page-header">
              <div class="ps-page-header__left">
                  <span class="ps-page-header__title">Apps</span>
              </div>
              <div class="ps-page-header__right" v-if="deviceDetail && deviceDetail.profile_id">
                  <span class="ps-page-header__profile">{{ deviceDetail.profile_id.profile_name }}</span>
                  <span class="ps-page-header__device">{{ deviceDetail.hardwareInfo.brand }} {{ deviceDetail.hardwareInfo.model }}</span>
              </div>
            </div>

            <!-- Search Bar -->
            <div class="ps-search-wrap">
                <div class="ps-search">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="ps-search__icon">
                        <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8"/>
                        <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                    </svg>
                    <input
                        type="text"
                        class="ps-search__input"
                        placeholder="Search apps..."
                        v-model="playstoreText"
                        @keyup.enter="getPlayStore('Terms')"
                    />
                    <button v-if="playstoreText" class="ps-search__clear" @click="playstoreText = ''; getPlayStore()">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                </div>
            </div>

            <!-- Filter Pills -->
            <div class="ps-filters">
              <button
                  class="ps-filter-btn"
                  :class="{ 'ps-filter-btn--active': ageFilter }"
                  data-toggle="collapse"
                  data-target="#sortByPopup"
              >
                  Age Group
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </button>
              <button
                  class="ps-filter-btn"
                  :class="{ 'ps-filter-btn--active': filterCategory }"
                  data-toggle="collapse"
                  data-target="#filterByCategoryPopup"
              >
                  Category
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </button>
              <button
                  class="ps-filter-btn"
                  :class="{ 'ps-filter-btn--active': expertRatingFilter }"
                  data-toggle="collapse"
                  data-target="#expertRatingPopup"
              >
                  Expert Rating
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </button>
          </div>

            <!-- Filter Popups -->
            <div class="collapse ps-popup-wrap" id="sortByPopup">
                <div class="ps-popup">
                    <div class="ps-popup__header">
                        <span class="ps-popup__title">Age Group</span>
                        <button class="ps-popup__close" @click="closePopUp()">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                    <div class="ps-popup__body">
                        <div class="ps-radio-grid">
                            <label class="ps-radio" :class="{ 'ps-radio--active': ageFilter == 'AGE_RANGE1' }">
                                <input type="radio" v-model="ageFilter" value="AGE_RANGE1" /> Under 5
                            </label>
                            <label class="ps-radio" :class="{ 'ps-radio--active': ageFilter == 'AGE_RANGE2' }">
                                <input type="radio" v-model="ageFilter" value="AGE_RANGE2" /> Ages 6–8
                            </label>
                            <label class="ps-radio" :class="{ 'ps-radio--active': ageFilter == 'AGE_RANGE3' }">
                                <input type="radio" v-model="ageFilter" value="AGE_RANGE3" /> Ages 9+
                            </label>
                            <label class="ps-radio" :class="{ 'ps-radio--active': ageFilter == 'AGE_RANGE_ALL' }">
                                <input type="radio" v-model="ageFilter" value="AGE_RANGE_ALL" /> All up to 12
                            </label>
                        </div>
                    </div>
                    <div class="ps-popup__footer">
                        <button class="ps-popup__clear" @click="clearAgeFilter()">Clear</button>
                        <button class="ps-popup__apply" @click="getPlayStore('Age')">Apply</button>
                    </div>
                </div>
            </div>

            <div class="collapse ps-popup-wrap" id="filterByCategoryPopup">
                <div class="ps-popup">
                    <div class="ps-popup__header">
                        <span class="ps-popup__title">Category</span>
                        <button class="ps-popup__close" @click="closePopUp()">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                    <div class="ps-popup__body ps-popup__body--scroll">
                        <div class="ps-radio-grid">
                            <template v-for="parentCat in playStoreCategories" :key="parentCat">
                                <label
                                    v-for="category in parentCat"
                                    :key="category"
                                    class="ps-radio"
                                    :class="{ 'ps-radio--active': filterCategory == category }"
                                    style="text-transform: capitalize; font-size: 12px;"
                                >
                                    <input type="radio" v-model="filterCategory" :value="category" />
                                    {{ category.replace(/_/g, ' ').toLowerCase() }}
                                </label>
                            </template>
                        </div>
                    </div>
                    <div class="ps-popup__footer">
                        <button class="ps-popup__clear" @click="clearCategoryFilter()">Clear</button>
                        <button class="ps-popup__apply" @click="getPlayStore('Category')">Apply</button>
                    </div>
                </div>
            </div>

            <div class="collapse ps-popup-wrap" id="expertRatingPopup">
                <div class="ps-popup">
                    <div class="ps-popup__header">
                        <span class="ps-popup__title">Expert Rating</span>
                        <button class="ps-popup__close" @click="closePopUp()">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                    <div class="ps-popup__body">
                        <div class="ps-radio-list">
                            <label class="ps-radio-row" :class="{ 'ps-radio-row--active': expertRatingFilter == 'EXPERT_RECOMMENDATION' }">
                                <input type="radio" v-model="expertRatingFilter" value="EXPERT_RECOMMENDATION" />
                                <img :src="exportGreen" width="18" style="margin-right:6px;" />
                                Recommended
                            </label>
                            <label class="ps-radio-row" :class="{ 'ps-radio-row--active': expertRatingFilter == 'PARENTAL_SUPERVISION' }">
                                <input type="radio" v-model="expertRatingFilter" value="PARENTAL_SUPERVISION" />
                                <img :src="exportOrange" width="18" style="margin-right:6px;" />
                                Recommended with parental supervision
                            </label>
                        </div>
                    </div>
                    <div class="ps-popup__footer">
                        <button class="ps-popup__clear" @click="clearExpertRatingFilter()">Clear</button>
                        <button class="ps-popup__apply" @click="getPlayStore('ExpertRating')">Apply</button>
                    </div>
                </div>
            </div>

            <!-- Tabs: Installed / Search Results -->
            <div class="ps-tabs">
                
                   <a class="ps-tab"
                    :class="{ 'ps-tab--active': activeTab === 'installed' }"
                    href="javascript:void(0)"
                    @click="switchTab('installed')"
                >Installed</a>
                
                    <a class="ps-tab"
                    :class="{ 'ps-tab--active': activeTab === 'search' }"
                    href="javascript:void(0)"
                    @click="switchTab('search')"
                    id="all"
                >Search Results</a>
            </div>
            <!-- Tab Content -->
            <div class="tab-content">

                <!-- Search Results Tab -->
                <div v-show="activeTab === 'search'">
                    <div class="ps-result-label" v-if="playstoreLabel && playstoreLabel !== 'No data found'">
                        {{ playstoreLabel }}
                    </div>
                    <div class="ps-loader" v-if="showLoader">
                        <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
                    </div>
                    <div class="apps-card" v-if="!showLoader && playStoreApplications.length > 0">
                        <template v-for="application in playStoreApplications" :key="application._id">
                            <div class="app-row" v-if="!hiddenPackages.includes(application.appId)"
                                @click="$router.push({ path: '/application', query: { package_name: application.appId, profile_id: profileId, serialNumber: serialNumber, playstoreText: playstoreText, filterCategory: filterCategory, ageFilter: ageFilter, expertRatingFilter: expertRatingFilter } })">
                                <div class="app-row__icon">
                                    <img :src="application.icon" width="44" height="44" style="border-radius: 12px; display: block;" />
                                </div>
                                <div class="app-row__info">
                                    <div class="app-row__top">
                                        <span class="app-row__name">{{ application.title }}</span>
                                        <span class="app-row__time" v-if="application.price > 0">{{ application.currency }} {{ application.price }}</span>
                                    </div>
                                    <div class="app-row__ratings">
                                        <span class="app-row__rating-item">
                                            <svg width="11" height="11" viewBox="0 0 24 24" fill="#f59e0b"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                                            {{ application.scoreText }}
                                        </span>
                                        <span class="app-row__rating-item">
                                            <img v-if="application.kidsRating.avgKidsRating >= 3" :src="childPositiveSmile" width="13" />
                                            <img v-else-if="application.kidsRating.avgKidsRating >= 2" :src="childNeutralSmile" width="13" />
                                            <img v-else-if="application.kidsRating.avgKidsRating >= 1" :src="childNegativeSmile" width="13" />
                                            <i v-else class="far fa-smile" style="font-size:13px; color:#9ca3af;"></i>
                                            {{ application.overallRating }}
                                        </span>
                                        <span class="app-row__rating-item" v-if="application.expertRating">
                                            <img v-if="application.expertRating == 'EXPERT_RECOMMENDATION'" :src="exportGreen" width="13"/>
                                            <img v-else-if="application.expertRating == 'PARENTAL_SUPERVISION'" :src="exportOrange" width="13"/>
                                            <img v-else-if="application.expertRating == '16+'" :src="sixteenPlus" width="13"/>
                                            <img v-else :src="notRated" width="13"/>
                                        </span>
                                    </div>
                                    <!-- Social media warning -->
                                    <div class="ps-warning ps-warning--danger" v-if="socialMediaPackages.includes(application.appId)">
                                        Not recommended for children
                                    </div>
                                    <!-- Paid warning -->
                                    <div class="ps-warning" v-if="application.free == false && application.isAppInstalled == false">
                                        Paid apps require purchase via app management program
                                    </div>
                                </div>
                                <!-- Install / Uninstall -->
                                <div class="app-row__action" @click.stop v-if="application.free == true">
                                    <button
                                        v-if="application.isAppInstalled == false"
                                        class="ps-install-btn"
                                        :disabled="isDisabled"
                                        @click="openDailyLimitSetPopup(application)"
                                    >Install</button>
                                    <button
                                        v-else
                                        class="ps-uninstall-btn"
                                        :disabled="isDisabled"
                                        @click="uninstallProfileApplication(application.appId)"
                                    >
                                        <TrashIcon />
                                        <i v-if="isDisabled" class="fa fa-spinner fa-spin"></i>
                                    </button>
                                </div>
                                <div class="app-row__chevron" v-else>
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                        <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="apps-card__empty" v-if="!showLoader && playStoreApplications.length === 0 && playstoreLabel !== 'No data found'">
                        <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                            <circle cx="11" cy="11" r="8" stroke="#d1d5db" stroke-width="1.5"/>
                            <path d="M21 21l-4.35-4.35" stroke="#d1d5db" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        <span>No apps found</span>
                    </div>
                </div>

                <!-- Installed Apps Tab -->
                <div v-show="activeTab === 'installed'">
                    <div class="ps-loader" v-if="showInstallAppLoader">
                        <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
                    </div>
                    <div class="apps-card" v-if="!showInstallAppLoader && installedApplicationList.length > 0">
                        <div
                            class="app-row"
                            v-for="application in installedApplicationList"
                            :key="application._id"
                            :style="{ opacity: application.is_app_disabled ? 0.6 : 1 }"
                            @click="$router.push({ path: '/application', query: { package_name: application.package_name, profile_id: profileId, serialNumber: serialNumber, playstoreText: playstoreText, filterCategory: filterCategory, ageFilter: ageFilter, expertRatingFilter: expertRatingFilter } })"
                        >
                            <div class="app-row__icon">
                                <img :src="application.app_icon" width="44" height="44" style="border-radius: 12px; display: block;" />
                            </div>
                            <div class="app-row__info">
                                <div class="app-row__top">
                                    <span class="app-row__name">{{ getAppTitle(application.display_text) }}</span>
                                    <span class="app-row__badge--disabled" v-if="application.is_app_disabled">
                                        Disabled
                                        <span v-if="application.appEnabledDisabledType"> · {{ getReasonText(application.appEnabledDisabledType) }}</span>
                                    </span>
                                </div>
                                <div class="app-row__ratings">
                                    <span class="app-row__rating-item">
                                        <svg width="11" height="11" viewBox="0 0 24 24" fill="#f59e0b"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                                        {{ application.playstoreDetail ? application.playstoreDetail.scoreText : '0.0' }}
                                    </span>
                                    <span class="app-row__rating-item">
                                        <img v-if="application.kidsRating.avgKidsRating >= 3" :src="childPositiveSmile" width="13" />
                                        <img v-else-if="application.kidsRating.avgKidsRating >= 2" :src="childNeutralSmile" width="13" />
                                        <img v-else-if="application.kidsRating.avgKidsRating >= 1" :src="childNegativeSmile" width="13" />
                                        <i v-else class="far fa-smile" style="font-size:13px; color:#9ca3af;"></i>
                                        {{ application.overallRating }}
                                    </span>
                                    <span class="app-row__rating-item" v-if="application.expertRating">
                                        <img v-if="application.expertRating == 'EXPERT_RECOMMENDATION'" :src="exportGreen" width="13"/>
                                        <img v-else-if="application.expertRating == 'PARENTAL_SUPERVISION'" :src="exportOrange" width="13"/>
                                        <img v-else-if="application.expertRating == '16+'" :src="sixteenPlus" width="13"/>
                                        <img v-else :src="notRated" width="13"/>
                                    </span>
                                    <span class="app-row__rating-item" v-if="application.installationFailureReason">
                                        <a href="javascript:void(0)" @click.stop="openAppInstallationErrorPopup(application.installationFailureReason)" style="color:#dc2626;">
                                            <i class="fas fa-exclamation-circle"></i>
                                        </a>
                                    </span>
                                </div>
                                <!-- Daily limit progress -->
                                <div class="app-row__progress-wrap" v-if="application.enableDailyLimit">
                                    <div class="app-row__progress-track">
                                        <div
                                            class="app-row__progress-fill"
                                            :class="{ 'app-row__progress-fill--danger': (application.usedLimitNumber / application.dailyLimitTimeNumber * 100) >= 100 }"
                                            :style="{ width: Math.min((application.usedLimitNumber / application.dailyLimitTimeNumber * 100), 100) + '%' }"
                                        ></div>
                                    </div>
                                    <span class="app-row__progress-label">
                                        {{ application.usedLimit }} / {{ application.dailyLimitTime }}
                                    </span>
                                </div>
                                <!-- Warnings -->
                                <div class="ps-warning" v-if="isProtectedApp(application.package_name)">
                                    Special app · cannot be uninstalled
                                </div>
                                <div class="ps-warning" v-else-if="application.isSystemApp == true">
                                    System app · cannot be uninstalled
                                </div>
                            </div>
                            <!-- Action -->
                            <div class="app-row__action" @click.stop v-if="!isProtectedApp(application.package_name) && application.isSystemApp == false">
                                <button class="ps-uninstall-btn" :disabled="isDisabled" @click="uninstallProfileApplication(application.package_name)">
                                    <TrashIcon />
                                    <i v-if="isDisabled" class="fa fa-spinner fa-spin"></i>
                                </button>
                            </div>
                            <div class="app-row__chevron" v-else>
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="apps-card__empty" v-if="!showLoader && installedApplicationList.length === 0">
                        <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                            <rect x="3" y="3" width="18" height="18" rx="4" stroke="#d1d5db" stroke-width="1.5"/>
                            <path d="M9 12h6M12 9v6" stroke="#d1d5db" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        <span>No apps installed</span>
                    </div>
                </div>
            </div>

            <!-- App Installation Error Popup -->
            <div v-if="showInstallErrorPopup" class="ps-modal-overlay" @click.self="closeAppInstallationErrorPopup()">
                <div class="ps-modal">
                    <div class="ps-popup__header">
                        <span class="ps-popup__title">Installation Status</span>
                        <button class="ps-popup__close" @click="closeAppInstallationErrorPopup()">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                    <div class="ps-popup__body">
                        <p style="font-size: 13px; color: #374151; line-height: 1.5;">{{ appInstallaionErrors[installationFailureReason] }}</p>
                    </div>
                </div>
            </div>

            <!-- Daily Limit Popup -->
            <div v-if="showDailyLimitPopup" class="ps-modal-overlay" @click.self="closeDailyLimitSetPopup()">
                <div class="ps-modal">
                    <div class="ps-popup__header">
                        <span class="ps-popup__title">{{ app ? 'Install: ' + app.title : 'Daily Limit' }}</span>
                        <button class="ps-popup__close" @click="closeDailyLimitSetPopup()">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                    <div class="ps-popup__body">
                        <p class="ps-popup__desc">Set a daily time limit to ensure healthy app usage. The app will be disabled once the limit is reached.</p>
                        <div class="req-popup__toggle-row">
                            <span class="req-popup__toggle-label">Enable daily limit</span>
                            <label class="kid-action-switch">
                                <input type="checkbox" v-model="enableDailyLimit" />
                                <span class="kid-action-switch__track"></span>
                            </label>
                        </div>
                        <div class="req-popup__limit-row" style="margin-top: 14px;">
                            <span class="req-popup__limit-label">Daily limit (minutes)</span>
                            <div class="req-popup__stepper">
                                <button class="req-popup__step-btn" @click="decreaseLimit()"><ArrowLeftIcon /></button>
                                <input type="text" class="req-popup__step-input" :disabled="!enableDailyLimit" v-model="dailyLimitTime" @blur="roundOF15()" />
                                <button class="req-popup__step-btn" @click="increaseLimit()"><ArrowRightIcon /></button>
                            </div>
                        </div>
                    </div>
                    <div class="ps-popup__footer ps-popup__footer--stack">
                        <button class="req-action-btn req-action-btn--primary" @click="saveAppDailyLimit()" :disabled="isDisabled || dailyLimitTime <= 0">
                            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i> Installing...</span>
                            <span v-else>Install with Time Limit</span>
                        </button>
                        <button class="req-action-btn req-action-btn--secondary" @click="saveAppDailyLimit(true)" :disabled="isDisabled">
                            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                            <span v-else>Install without Time Limit</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Last updated -->
            <div class="last-updated">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style="flex-shrink:0">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
                    <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
                Last updated: {{ lastUpdated }}
            </div>

            <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
        </div>
    </div>
</template>

<script>
const SYSTEM_APP_TITLE_MAP = {
  'com.samsung.android.incallui': 'Phone',
  'com.samsung.android.dialer': 'Phone',
  'com.android.settings': 'Settings',
  'com.android.vending': 'Google Play Store',
  'com.sec.android.gallery3d': 'Gallery',
  'com.sec.android.app.camera': 'Camera',
  'com.samsung.android.app.contacts': 'Contacts',
  'com.wingio.hwbview': 'Android WebView'
};

import KidHeader from '@/components/KidHeader.vue'
import ProfileService from "../../services/ProfileService";
import KidsService from "../../services/KidsService";
import KidFooter from '@/components/KidFooter.vue'
import DownArrowIcon from '@/components/icons/DownArrowIcon.vue'
import TrashIcon from '@/components/icons/TrashIcon.vue'
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue'
import ArrowRightIcon from '@/components/icons/ArrowRightIcon.vue'
import ArrowLeftBackIcon from '@/components/icons/ArrowLeftBackIcon.vue'
import CrossCloseIcon from '@/components/icons/CrossCloseIcon.vue'
import StarGoldIcon from '@/components/icons/StarGoldIcon.vue'

export default {
  name: 'Play Store',
  components: {
    KidHeader,
    KidFooter,
    DownArrowIcon,
    TrashIcon,
    ArrowRightIcon,
    ArrowLeftIcon,
    ArrowLeftBackIcon,
    CrossCloseIcon,
    StarGoldIcon
  },
  props: {
    notRated: { type: String, default: "./images/not-certified.png" },
    exportOrange: { type: String, default: "./images/experts-orange.png" },
    exportGreen: { type: String, default: "./images/experts-green.png" },
    sixteenPlus: { type: String, default: "./images/16-plus.png" },
    childPositiveSmile: { type: String, default: "./images/child-positive-smile.png" },
    childNeutralSmile: { type: String, default: "./images/child-neutral-smile.png" },
    childNegativeSmile: { type: String, default: "./images/child-negative-smile.png" },
  },
  data() {
    return {
      showDailyLimitPopup: false,
      showInstallErrorPopup: false,
        showLoader: false,
        showInstallAppLoader: false,
        isDisabled: false,
        installedApplicationList: [],
        profileId: this.$route.query.profileId,
        serialNumber: this.$route.query.serialNumber,
        playstoreText: this.$route.query.playstoreText,
        playStoreApplications: [],
        deviceDetail: null,
        ageFilter: this.$route.query.ageFilter,
        filterCategory: this.$route.query.filterCategory,
        expertRatingFilter: this.$route.query.expertRatingFilter,
        playStoreCategories: [],
        playstoreLabel: "No data found",
        lastUpdated: "No data found.",
        installationFailureReason: "",
        activeTab: 'installed',
        appInstallaionErrors: {
            "INSTALLATION_FAILURE_REASON_UNKNOWN": "An unknown condition is preventing the app from being installed. Some potential reasons are that the device doesn't have enough storage, the device network connection is unreliable, or the installation is taking longer than expected. The installation will be retried automatically.",
            "IN_PROGRESS": "The installation is still in progress.",
            "NOT_FOUND": "The app was not found in Play.",
            "NOT_COMPATIBLE_WITH_DEVICE": "The app is incompatible with the device.",
            "NOT_APPROVED": "The app has not been approved by the admin.",
            "PERMISSIONS_NOT_ACCEPTED": "The app has new permissions that have not been accepted by the admin.",
            "NOT_AVAILABLE_IN_COUNTRY": "The app is not available in the user's country.",
            "NO_LICENSES_REMAINING": "There are no licenses available to assign to the user.",
            "NOT_ENROLLED": "The enterprise is no longer enrolled with Managed Google Play or the admin has not accepted the latest Managed Google Play Terms of Service.",
            "USER_INVALID": "The user is no longer valid. The user may have been deleted or disabled.",
            "NETWORK_ERROR_UNRELIABLE_CONNECTION": "A network error on the user's device has prevented the install from succeeding.",
            "INSUFFICIENT_STORAGE": "The user's device does not have sufficient storage space to install the app."
        },
        hiddenPackages: [],
        socialMediaPackages: ['com.nova.kidsfirstphone','com.facebook.katana','com.facebook.lite','com.facebook.orca','com.facebook.mlite','com.facebook.pages.app','com.instagram.android','com.instagram.lite','com.instagram.barcelona','com.twitter.android','com.twitter.android.lite','com.zhiliaoapp.musically','com.zhiliaoapp.musically.go','com.snapchat.android','org.telegram.messenger','org.telegram.messenger.web','org.telegram.messenger.beta','com.reddit.frontpage','com.linkedin.android','com.pinterest','com.discord','com.skype.raider','com.viber.voip','com.tumblr','com.bigo.live','com.yubo.application','co.yellw.yubo','com.weheartit','com.wattpad','com.quora.android','com.clubhouse.app','com.tmtg.apps.truthsocial','com.bereal.ft','com.vkontakte.android','com.jappy.android','video.like','com.kik.android','com.houseparty','com.whisper','com.monkey','com.look.app','com.yikyak','com.youown.yo','com.meetme','com.omegle','com.tinder','com.bumble','com.afterfocus.app','com.sarahah.app','com.yoowolf.app'],
        enableDailyLimit: true,
        dailyLimitTime: 60,
        app: null,
        protectedApps: [
          'com.samsung.android.app.contacts',
          'com.samsung.android.dialer',
          'com.samsung.android.messaging',
          'com.mywingio.dialer'
        ],
    }
  },
  methods: {
      switchTab(tab) {
        this.activeTab = tab;
    },
    isProtectedApp(packageName) {
      return this.protectedApps.includes(packageName);
    },
    getAppTitle(appName) {
      return SYSTEM_APP_TITLE_MAP[appName] || appName;
    },
    getDeviceProfileApplicationList() {
      this.showInstallAppLoader = true;
      let data = { profile_id: this.profileId, install_type: "FORCE_INSTALLED", serialNumber: this.serialNumber };
      ProfileService.getDeviceProfileApplicationList(data)
        .then((response) => { this.showInstallAppLoader = false; this.installedApplicationList = response.data.data; })
        .catch((e) => { this.showInstallAppLoader = false; this.$toast.error(e.response.data.respones_msg); });
    },
    async getPlayStore(currentFilter = null) {
      this.showLoader = true;
      $('#sortByPopup').collapse('hide');
      $('#filterByCategoryPopup').collapse('hide');
      $('#expertRatingPopup').collapse('hide');
      if (currentFilter == "Terms") { this.ageFilter = ""; this.filterCategory = ""; this.expertRatingFilter = ""; }
      else if (currentFilter == "Age") { this.filterCategory = ""; this.playstoreText = ""; this.expertRatingFilter = ""; }
      else if (currentFilter == "Category") { this.playstoreText = ""; this.ageFilter = ""; this.expertRatingFilter = ""; }
      this.isDisabled = true;
      let data = { profileId: this.profileId, serialNumber: this.serialNumber, playstoreText: this.playstoreText, ageFilter: this.ageFilter, filterCategory: this.filterCategory, expertRatingFilter: this.expertRatingFilter };
      if (this.ageFilter) {
          this.activeTab = 'search';
          if (this.ageFilter == "AGE_RANGE1") { this.playstoreLabel = "Show result for Ages up to 5"; }
          else if (this.ageFilter == "AGE_RANGE2") { this.playstoreLabel = "Show result for Ages 6-8"; }
          else if (this.ageFilter == "AGE_RANGE3") { this.playstoreLabel = "Show result for Ages 9-12"; }
          else { this.playstoreLabel = "Show result for All ages up to 12"; }
          this.filterCategory = "";
      } else if (this.filterCategory) {
          this.activeTab = 'search';
          this.playstoreLabel = "Show result for " + this.filterCategory.replace(/_/g, ' ') + " Category";
      } else if (this.playstoreText) {
          this.playstoreLabel = "Show result for " + this.playstoreText;
          this.activeTab = 'search';
      } else if (this.expertRatingFilter) {
          let lable = (this.expertRatingFilter == "EXPERT_RECOMMENDATION") ? "Expert Recommendation" : "Expert Recommendation With Parental Supervision";
          if (this.expertRatingFilter == "NOT_RATED") { lable = "Not Certified"; }
          this.playstoreLabel = "Show result for " + lable;
          this.activeTab = 'search';
      } else {
          this.playstoreLabel = "No data found";
      }
      this.playStoreApplications = [];
      await KidsService.getPlayStore(data)
          .then((response) => {
              this.showLoader = false;
              this.playStoreApplications = response.data.data;
              this.isDisabled = false;
              this.deviceDetail = response.data.deviceDetail;
              if (this.deviceDetail && this.deviceDetail.lastDeviceActivationDate) {
                  this.lastUpdated = new Date(this.deviceDetail.lastDeviceActivationDate).toLocaleDateString("en-US", this.$dateOptions) + " " + new Date(this.deviceDetail.lastDeviceActivationDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
              } else { this.lastUpdated = "No data found."; }
          })
          .catch((e) => { this.showLoader = false; this.playStoreApplications = []; this.isDisabled = false; this.$toast.error(e); });
    },
    closePopUp() {
      $('#sortByPopup').collapse('hide');
      $('#filterByCategoryPopup').collapse('hide');
      $('#expertRatingPopup').collapse('hide');
    },
    async clearExpertRatingFilter() { this.expertRatingFilter = ""; await this.getPlayStore(); $('#expertRatingPopup').collapse('hide'); },
    async clearAgeFilter() { this.ageFilter = ""; await this.getPlayStore(); $('#sortByPopup').collapse('hide'); },
    async clearCategoryFilter() { this.filterCategory = ""; await this.getPlayStore(); $('#filterByCategoryPopup').collapse('hide'); },
    async createProfileApplication(app, skipDailyConfiguration = false) {
        this.isDisabled = true;
        let masterApplicationData = { product_id: app.appId, package_name: app.appId, app_icon: app.icon, application_details: app, type: this.deviceDetail && this.deviceDetail.profile_id && this.deviceDetail.profile_id.profile_type === "Ios" ? "Ios" : "Android" };
        await ProfileService.createMasterApplication(masterApplicationData).then(() => {}).catch(() => {});
        let data = { profile_id: this.profileId, package_name: app.appId, is_web_app: false, application_details: app, type: this.deviceDetail && this.deviceDetail.profile_id && this.deviceDetail.profile_id.profile_type === "Ios" ? "Ios" : "Android", serialNumber: this.serialNumber, enableDailyLimit: (skipDailyConfiguration == true) ? false : this.enableDailyLimit, dailyLimitTime: (skipDailyConfiguration == true) ? 0 : this.dailyLimitTime };
        await ProfileService.createProfileApplication(data)
          .then((response) => {
              let profileType = this.deviceDetail && this.deviceDetail.profile_id && this.deviceDetail.profile_id.profile_type === "Ios" ? "Ios" : "Android";
              if (profileType == "Ios") { this.iosApplyPolicy(); } else { this.applyPolicy(); }
              this.isDisabled = false;
              //this.$toast.success(response.data.respones_msg);
              this.enableDailyLimit = true;
              this.dailyLimitTime = 60;
              this.showDailyLimitPopup = false;
              this.getPlayStore();
              this.getDeviceProfileApplicationList();
          })
          .catch((e) => { this.isDisabled = false; this.$toast.error(e.response.data.respones_msg); });
    },
    async uninstallProfileApplication(package_name) {
      this.isDisabled = true;
      var data = { package_name: package_name, profile_id: this.profileId, serialNumber: this.serialNumber };
      await ProfileService.uninstallProfileApplication(data)
        .then(async (response) => {
            let profileType = this.deviceDetail && this.deviceDetail.profile_id && this.deviceDetail.profile_id.profile_type === "Ios" ? "Ios" : "Android";
            if (profileType == "Ios") { this.iosApplyPolicy(); } else { await this.applyPolicy(); }
            this.deleteProfileApplication(package_name);
            this.isDisabled = false;
            //this.$toast.success(response.data.respones_msg);
        }).catch((e) => { this.isDisabled = false; this.$toast.error(e.response.data.respones_msg); });
    },
    deleteProfileApplication(package_name) {
        this.isDisabled = true;
        var data = { package_name: package_name, profile_id: this.profileId, serialNumber: this.serialNumber };
        ProfileService.deleteProfileApplication(data)
        .then((response) => { this.isDisabled = false; 
        //this.$toast.success(response.data.respones_msg); 
        this.getPlayStore(); this.getDeviceProfileApplicationList(); })
        .catch((e) => { this.isDisabled = false; this.$toast.error(e.response.data.respones_msg); });
    },
    iosApplyPolicy() {
        this.isDisabled = true;
        let data = { profile_id: this.profileId };
        ProfileService.iosApplyPolicy(data).then((response) => { 
            //this.$toast.success(response.data.respones_msg);
             this.isDisabled = false; }).catch((e) => { this.$toast.error(e.response.data.respones_msg); this.isDisabled = false; });
    },
    async applyPolicy() {
      this.isDisabled = true;
      let data = { profile_id: this.profileId, serialNumber: this.serialNumber };
      await ProfileService.applyPolicy(data).then((response) => { this.isDisabled = false; 
        //this.$toast.success(response.data.respones_msg);
       }).catch(() => { this.isDisabled = false; });
    },
    openAppInstallationErrorPopup(reason) {
        this.installationFailureReason = reason;
        this.showInstallErrorPopup = true;
    },
    closeAppInstallationErrorPopup() {
        this.showInstallErrorPopup = false;
        this.installationFailureReason = "";
    },

    async openDailyLimitSetPopup(app) {
        this.app = app;
        this.enableDailyLimit = true;
        this.dailyLimitTime = 60;
        this.showDailyLimitPopup = true;
    },
    async saveAppDailyLimit(skipDailyConfiguration) { return await this.createProfileApplication(this.app, skipDailyConfiguration); },
    closeDailyLimitSetPopup() {
        this.showDailyLimitPopup = false;
    },
    decreaseLimit() { if (this.dailyLimitTime > 0) { this.dailyLimitTime = this.dailyLimitTime - 15; } },
    increaseLimit() { this.dailyLimitTime = (parseInt(this.dailyLimitTime) + 15); },
    roundOF15() { this.dailyLimitTime = Math.ceil(this.dailyLimitTime / 15.0) * 15; },
    getReasonText(type) {
      switch (type) {
        case 'Manually': return 'manually';
        case 'Overuse': return 'due to app time limit';
        case 'Category Overuse': return 'due to category time limit';
        case 'Cronjob': return 'via schedule';
        case 'Global Daily Limit Reach': return 'due to device time limit';
        default: return '';
      }
    }
  },
  beforeMount() {
    this.getPlayStore();
    this.getDeviceProfileApplicationList();
    let array = ['ANDROID_WEAR','APPLICATION','ART_AND_DESIGN','AUTO_AND_VEHICLES','BEAUTY','BOOKS_AND_REFERENCE','BUSINESS','COMICS','COMMUNICATION','DATING','EDUCATION','ENTERTAINMENT','EVENTS','FAMILY','FINANCE','FOOD_AND_DRINK','GAME','GAME_ACTION','GAME_ADVENTURE','GAME_ARCADE','GAME_BOARD','GAME_CARD','GAME_CASINO','GAME_CASUAL','GAME_EDUCATIONAL','GAME_MUSIC','GAME_PUZZLE','GAME_RACING','GAME_ROLE_PLAYING','GAME_SIMULATION','GAME_SPORTS','GAME_STRATEGY','GAME_TRIVIA','GAME_WORD','HEALTH_AND_FITNESS','HOUSE_AND_HOME','LIBRARIES_AND_DEMO','LIFESTYLE','MAPS_AND_NAVIGATION','MEDICAL','MUSIC_AND_AUDIO','NEWS_AND_MAGAZINES','PARENTING','PERSONALIZATION','PHOTOGRAPHY','PRODUCTIVITY','SHOPPING','SOCIAL','SPORTS','TOOLS','TRAVEL_AND_LOCAL','VIDEO_PLAYERS','WATCH_FACE','WEATHER'];
    const chunkSize = 3;
    let finalArray = [];
    for (let i = 0; i < array.length; i += chunkSize) { finalArray.push(array.slice(i, i + chunkSize)); }
    this.playStoreCategories = finalArray;
  },
}
</script>

<style scoped>
/* ── Page Header ── */
/* ── Page Header ── */
.ps-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px 8px;
    width: 100%; 
}

.ps-page-header__left {
    display: flex;
    flex-direction: column;
}

.ps-page-header__title {
    font-size: 20px;
    font-weight: 700;
    color: #111;
    line-height: 1.2;
}

.ps-page-header__right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
}

.ps-page-header__profile {
    font-size: 13px;
    font-weight: 600;
    color: #111;
}

.ps-page-header__device {
    font-size: 11px;
    color: #6b7280;
}

/* ── Search ── */
.ps-search-wrap {
    padding: 10px 14px 8px;
    width: 100%;
}

.ps-search {
    display: flex;
    align-items: center;
    /*background: #f3f4f6;*/
    border-radius: 12px;
    padding: 0 12px;
    gap: 8px;
    height: 42px;
    border: 0.5px solid #e5e7eb;
}

.ps-search__icon { color: #9ca3af; flex-shrink: 0; }

.ps-search__input {
    flex: 1;
    border: none;
    background: transparent;
    font-size: 14px;
    color: #111;
    outline: none;
}

.ps-search__input::placeholder { color: #9ca3af; }

.ps-search__clear {
    background: none;
    border: none;
    color: #9ca3af;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    -webkit-tap-highlight-color: transparent;
}
/* ── Filter Pills ── */
.ps-filters {
    display: flex;
    gap: 6px;
    padding: 0 14px 12px;
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
    border-bottom: 0.5px solid #f3f4f6;
    width: 100%;
}

.ps-filters::-webkit-scrollbar { display: none; }

.ps-filter-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 7px 13px;
    border-radius: 20px;
    border: 0.5px solid #e5e7eb;
    background: #fff;
    font-size: 12px;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
    -webkit-tap-highlight-color: transparent;
    transition: all 0.15s;
}

.ps-filter-btn--active {
    background: #eff6ff;
    border-color: #bfdbfe;
    color: #1d4ed8;
    font-weight: 600;
}

/* ── Tabs ── */

.ps-tabs {
    display: flex;
    padding: 0 14px;
    gap: 0;
    background: #fff;
    border-bottom: 0.5px solid #e5e7eb;
    margin-bottom: 10px;
    text-align: left;
    width: 100%;
}

.ps-tab {
    padding: 11px 16px 10px;
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
    text-decoration: none;
    border-bottom: 2.5px solid transparent;
    margin-bottom: -0.5px;
    -webkit-tap-highlight-color: transparent;
    transition: color 0.15s, border-color 0.15s;
}

.ps-tab--active {
    color: #2563eb;
    font-weight: 700;
    border-bottom-color: #2563eb;
}

/* ── App rows — reuse from dashboard ── */
.apps-card {
    background: #fff;
    border-radius: 14px;
    border: 0.5px solid #e5e7eb;
    margin: 0 14px 8px;
    overflow: hidden;
}
.app-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-bottom: 1px solid #f3f4f6;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.app-row:last-child { border-bottom: none; }
.app-row:active { background: #f9fafb; }
.app-row__icon { flex-shrink: 0; }
.app-row__info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.app-row__top { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.app-row__name { text-align: left; font-size: 13px; font-weight: 500; color: #111; flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.app-row__time { font-size: 12px; font-weight: 500; color: #6b7280; white-space: nowrap; flex-shrink: 0; }
.app-row__badge--disabled { font-size: 10px; font-weight: 600; background: #fee2e2; color: #dc2626; padding: 2px 7px; border-radius: 20px; white-space: nowrap; }
.app-row__ratings { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.app-row__rating-item { display: inline-flex; align-items: center; gap: 3px; font-size: 11px; color: #6b7280; }
.app-row__progress-wrap { display: flex; flex-direction: column; gap: 3px; }
.app-row__progress-track { height: 4px; background: #f3f4f6; border-radius: 999px; overflow: hidden; width: 100%; }
.app-row__progress-fill { height: 100%; background: #2563eb; border-radius: 999px; min-width: 4px; }
.app-row__progress-fill--danger { background: #dc2626; }
.app-row__progress-label { font-size: 11px; color: #6b7280; font-weight: 500; text-align: left; }
.app-row__chevron { flex-shrink: 0; color: #d1d5db; }
.app-row__action { flex-shrink: 0; }

/* ── Install / Uninstall buttons ── */
.ps-install-btn {
    background: #2563eb;
    color: #fff;
    border: none;
    border-radius: 20px;
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.ps-install-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.ps-uninstall-btn {
    background: #fee2e2;
    color: #dc2626;
    border: none;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    -webkit-tap-highlight-color: transparent;
}
.ps-uninstall-btn:disabled { opacity: 0.6; cursor: not-allowed; }

/* ── Warnings ── */
.ps-warning {
    font-size: 11px;
    color: #92400e;
    background: #fffbeb;
    border-radius: 6px;
    padding: 4px 8px;
    margin-top: 2px;
    line-height: 1.4;
    text-align: left;
}
.ps-warning--danger {
    background: #fee2e2;
    color: #dc2626;
}

/* ── Empty state ── */
.apps-card__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 32px 14px;
    color: #9ca3af;
    font-size: 13px;
}

/* ── Loader ── */
.ps-loader {
    display: flex;
    justify-content: center;
    padding: 32px 0;
}

/* ── Result label ── */
.ps-result-label {
    font-size: 12px;
    color: #6b7280;
    padding: 8px 14px 4px;
    font-weight: 500;
}

/* ── Popup ── */
.ps-popup-wrap { padding: 0 14px 8px; }
.ps-popup {
    background: #fff;
    border-radius: 14px;
    border: 0.5px solid #e5e7eb;
    overflow: hidden;
}
.ps-popup__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 14px 11px;
    border-bottom: 0.5px solid #f3f4f6;
}
.ps-popup__title { font-size: 14px; font-weight: 700; color: #111; }
.ps-popup__close {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #f3f4f6;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #374151;
    -webkit-tap-highlight-color: transparent;
}
.ps-popup__body { padding: 14px; }
.ps-popup__body--scroll { max-height: 300px; overflow-y: auto; -webkit-overflow-scrolling: touch; }
.ps-popup__desc { font-size: 12px; color: #6b7280; line-height: 1.5; margin: 0 0 12px; }
.ps-popup__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px 14px;
    border-top: 0.5px solid #f3f4f6;
    gap: 10px;
}
.ps-popup__footer--stack { flex-direction: column; }
.ps-popup__clear { background: none; border: none; font-size: 13px; font-weight: 500; color: #6b7280; cursor: pointer; padding: 0; }
.ps-popup__apply { background: #2563eb; color: #fff; border: none; border-radius: 10px; padding: 8px 20px; font-size: 13px; font-weight: 600; cursor: pointer; }

/* ── Radio options ── */
.ps-radio-grid { display: flex; flex-wrap: wrap; gap: 8px; }
.ps-radio { display: inline-flex; align-items: center; gap: 6px; padding: 7px 12px; border-radius: 20px; border: 0.5px solid #e5e7eb; background: #f9fafb; font-size: 12px; font-weight: 500; color: #374151; cursor: pointer; -webkit-tap-highlight-color: transparent; }
.ps-radio input { display: none; }
.ps-radio--active { background: #eff6ff; border-color: #bfdbfe; color: #1d4ed8; font-weight: 600; }
.ps-radio-list { display: flex; flex-direction: column; gap: 8px; }
.ps-radio-row { display: flex; align-items: center; gap: 8px; padding: 10px 12px; border-radius: 10px; border: 0.5px solid #e5e7eb; background: #f9fafb; font-size: 13px; color: #374151; cursor: pointer; }
.ps-radio-row input { display: none; }
.ps-radio-row--active { background: #eff6ff; border-color: #bfdbfe; color: #1d4ed8; }

/* ── Reuse switch + stepper from AppRequests ── */
.kid-action-switch { position: relative; display: inline-flex; width: 38px; height: 20px; cursor: pointer; margin: 0; }
.kid-action-switch input { opacity: 0; width: 0; height: 0; position: absolute; }
.kid-action-switch__track { position: absolute; inset: 0; background: #d1d5db; border-radius: 999px; transition: background 0.2s; }
.kid-action-switch__track::after { content: ''; position: absolute; top: 3px; left: 3px; width: 14px; height: 14px; background: white; border-radius: 50%; transition: transform 0.2s; }
.kid-action-switch input:checked + .kid-action-switch__track { background: #2563eb; }
.kid-action-switch input:checked + .kid-action-switch__track::after { transform: translateX(18px); }
.req-popup__toggle-row { display: flex; align-items: center; justify-content: space-between; background: #f9fafb; border-radius: 10px; padding: 10px 12px; }
.req-popup__toggle-label { font-size: 13px; font-weight: 500; color: #111; }
.req-popup__limit-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.req-popup__limit-label { font-size: 13px; font-weight: 500; color: #374151; flex: 1; }
.req-popup__stepper { display: flex; align-items: center; border: 0.5px solid #e5e7eb; border-radius: 10px; overflow: hidden; }
.req-popup__step-btn { width: 36px; height: 36px; background: #f9fafb; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #374151; -webkit-tap-highlight-color: transparent; }
.req-popup__step-btn:active { background: #f3f4f6; }
.req-popup__step-input { width: 56px; height: 36px; border: none; border-left: 0.5px solid #e5e7eb; border-right: 0.5px solid #e5e7eb; text-align: center; font-size: 14px; font-weight: 600; color: #111; background: #fff; outline: none; }
.req-action-btn { width: 100%; height: 44px; border-radius: 12px; border: none; font-size: 14px; font-weight: 600; cursor: pointer; -webkit-tap-highlight-color: transparent; }
.req-action-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.req-action-btn:active { opacity: 0.85; }
.req-action-btn--primary { background: #2563eb; color: #fff; }
.req-action-btn--secondary { background: #f3f4f6; color: #374151; }

/* ── Last updated ── */
.last-updated { display: flex; align-items: center; justify-content: center; gap: 5px; padding: 12px 0 16px; font-size: 12px; color: #9ca3af; }
.tab-content { width: 100% }
button:focus {
  outline: unset !important;
}
/* ── Modal overlay ── */
.ps-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1050;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
}

.ps-modal {
    background: #fff;
    border-radius: 20px 20px 0 0;
    width: 100%;
    max-width: 600px;
    max-height: 85vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    animation: slideUp 0.25s ease;
}

@keyframes slideUp {
    from { transform: translateY(100%); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
}
</style>